(() => {
  function setupTicker(scope = document) {
    const bars = [];
    if (scope.matches?.('.orv-topbar')) bars.push(scope);
    scope.querySelectorAll?.('.orv-topbar').forEach((bar) => bars.push(bar));

    bars.forEach((bar) => {
      if (bar.dataset.orvTickerReady === 'true') return;

      const inner = bar.querySelector('.orv-topbar__inner');
      if (!inner) return;

      const sourceItems = Array.from(inner.children).filter((el) => el.classList.contains('orv-topbar__item'));
      if (!sourceItems.length) return;

      const ticker = document.createElement('div');
      ticker.className = 'orv-mobile-ticker';
      ticker.setAttribute('aria-label', 'Store benefits');

      const track = document.createElement('div');
      track.className = 'orv-mobile-ticker__track';

      const buildSet = (hidden) => {
        const set = document.createElement('div');
        set.className = 'orv-mobile-ticker__set';
        if (hidden) set.setAttribute('aria-hidden', 'true');
        sourceItems.forEach((item) => set.appendChild(item.cloneNode(true)));
        return set;
      };

      track.appendChild(buildSet(false));
      track.appendChild(buildSet(true));
      ticker.appendChild(track);
      bar.appendChild(ticker);
      bar.classList.add('orv-has-mobile-ticker');
      bar.dataset.orvTickerReady = 'true';
    });
  }

  const init = () => setupTicker(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => setupTicker(event.target));
})();
